"use client"

import { motion, useReducedMotion } from "framer-motion"

const easeOut = [0.22, 1, 0.36, 1] as const

export function MarketingTrust() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="w-full min-w-0 py-44 sm:py-56">
      <motion.p
        className="mx-auto max-w-[66rem] text-center font-light leading-[1.72] tracking-[var(--type-tracking-heading)] text-foreground text-[length:var(--size-xl)] sm:text-[length:var(--size-2xl)]"
        initial={reduceMotion ? false : { opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: reduceMotion ? 0 : 0.6, ease: easeOut }}
      >
        Private by default.{" "}
        <span className="text-muted-foreground/78">
          Built for communities that still speak in full sentences.
        </span>
      </motion.p>
    </section>
  )
}
